import { Theme } from "@material-ui/core/styles";
import {
  buttonHoverColor,
  primaryColor,
  primaryColorLight,
  darkThemeFlag,
  buttonHoverColorLight,
} from "./palette";

const appStyles = (theme: Theme) => ({
  // modal: {
  //   display: "flex",
  //   alignItems: "center",
  //   justifyContent: "center",
  // },
  // modalPaper: {
  //   backgroundColor: theme.palette.background.paper,
  //   // border: '1px solid #000',
  //   // boxShadow: theme.shadows[5],
  //   padding: theme.spacing(2, 4, 3),
  // },
  app__container__marginTop: {
    marginTop: theme.spacing(2),
  },
  openDoorButton: {
    backgroundColor: !darkThemeFlag ? primaryColorLight : primaryColor,
    color: "#fff" + "!important",

    "&:hover": {
      backgroundColor: !darkThemeFlag ? buttonHoverColorLight : buttonHoverColor,
    },
  },
  "@global": {
    "*::-webkit-scrollbar": {
      width: "0.4em",
    },
    "*::-webkit-scrollbar-track": {
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
    },
    "*::-webkit-scrollbar-thumb": {
      backgroundColor: !darkThemeFlag ? primaryColorLight : primaryColor,
      outline: "1px solid slategrey",
    },
  },
});

export default appStyles;
